<template>
  <div class="member-order-list">
    <div class="common-header-wrap">
      <mt-header :title="$t('distributor.title.order_list')" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <!-- header -->
    <div class="order-header">
      <ul>
        <li
                class="item"
                v-for="item in orderNav"
                v-bind:key="item.id"
                v-bind:class="{ active: stateType == item.id }"
                v-on:click="setOrderNavActive(item.id)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
      <div class="order-body" v-if="order_group_list && order_group_list.length">
        <div v-for="item in order_group_list" :key="item.o2o_errand_order_id">
          <div class="list">
            <router-link :to="{name:'DistributorErrandOrderDetail',query:{o2o_errand_order_id:item.o2o_errand_order_id}}">
              <div class="tips-body">
                <span class="tips">{{ $t('distributor.errand_order_list.order_sn') }}: {{ item.o2o_errand_order_sn }} </span>
                <span class="title tips statusTips" >{{ $t(`distributor.errand.errand_send_state[${item.o2o_errand_order_state}]`) }}</span>
              </div>

              <div class="price">
                {{ $t('distributor.errand_order_list.total') }}: {{ $t('general.dollar_sign') }} <i>{{ utils.currencyPrice(item.o2o_errand_order_amount) }}</i>
              </div>
            </router-link>

          </div>

        </div>
      </div>
      <empty-record v-else-if="order_group_list && !order_group_list.length" style="padding-top: 10rem;"></empty-record>
    </div>
  </div>
</template>

<script>
import { getErrandOrderList } from '../../../api/distributorErrandOrder'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import { mapState } from 'vuex'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
  components: {
    EmptyRecord
  },
  name: 'MemberO2oErrandOrderList',
  data () {
    return {
      orderNav: [
        {
          'name': this.$t('distributor.errand_order_list.nav.all'),
          'id': ''
        },
        {
          'name': this.$t('distributor.errand_order_list.nav.occupied'),
          'id': '26'
        },
        {
          'name': this.$t('distributor.errand_order_list.nav.delivering'),
          'id': '30'
        },
        {
          'name': this.$t('distributor.errand_order_list.nav.done'),
          'id': '40'
        }
      ],
      stateType: this.$route.query.state ? this.$route.query.state : '',
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      order_group_list: false

    }
  },

  computed: {
    ...mapState({
    })
  },
  created: function () {
  },

  methods: {

    setOrderNavActive (index) {
      this.stateType = index
      this.getOrderList(true)
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getOrderList(false)
      }
    },
    getOrderList (ifReplace) {
      Indicator.open()
      if (ifReplace) {
        this.loading = false
        this.params.page = 1
        this.isMore = true
      }

      getErrandOrderList(this.params, '', { 'o2o_errand_order_state': this.stateType }).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        let tOrderGroup = res.result.order_list

        if (tOrderGroup) {
          if (ifReplace || !this.order_group_list) {
            this.order_group_list = tOrderGroup
          } else {
            this.order_group_list = this.order_group_list.concat(tOrderGroup)
          }
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
  .member-order-list {
    .order-header {
      position: fixed;
      height: 2.2rem;
      width: 100%;
      top: 4rem;
      z-index: 100;
      ul {
        list-style: none;
        width: auto;
        display: flex;
        justify-content: space-around;
        align-content: center;
        align-items: center;
        height: 100%;
        background: rgba(255, 255, 255, 1);
        border-bottom: 1px solid #e8eaed;
        li {
          font-size: 0.7rem;
          color: rgba(124, 127, 136, 1);
          height: 100%;
          text-align: center;
          line-height: 2.2rem;
          border-bottom: 0.1rem solid transparent;
          &.active {
            color: $primaryColor;
            border-bottom-color: $primaryColor;
          }
        }
      }
    }
    .order-body {
      position:relative;padding-top:2rem;
      .list {
        width: 100%;
        margin-top: 0.55rem;
        .tips-body {
          height: 2.2rem;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0 1px 0 0 rgba(232, 234, 237, 1);
          display: flex;
          justify-content: space-between;
          padding: 0 0.75rem 0 0.5rem;
          .tips {
            font-size: 0.7rem;
            color: #333333;
            line-height: 2.2rem;
          }
          .statusTips {
            color: #666666;
          }
          img {
            width: 3.8rem;
            height: 3rem;
          }
        }

        .price {
          font-size: 0.7rem;
          color: rgba(78, 84, 93, 1);
          line-height: 2.2rem;
          height: 2.2rem;
          background-color: #fff;
          padding: 0 0.75rem 0 0;
          border-bottom: 1px solid #e8eaed;
          box-sizing: border-box;
          text-align: right;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          i {
            font-size: 0.9rem;
            padding-left: 0.25rem;
            font-style: normal;
            &.freight {
              color: rgba(124, 127, 136, 1);
              font-size: 0.6rem;
            }
          }
        }
      }
      .loading-wrapper {
        text-align: center;
        p {
          color: #c3c3c3;
          font-size: 0.6rem;
          font-weight: 'Regular';
          margin: 0.5rem auto;
        }
      }
    }
    .mint-popup {
      width: 100%;
      height: 11.75rem;
    }
  }
</style>
